module.exports = __webpack_public_path__ + "img/914132910.efa43972.png";